import { render, staticRenderFns } from "./Rate.vue?vue&type=template&id=4fd3e20b&scoped=true&"
import script from "./Rate.vue?vue&type=script&lang=js&"
export * from "./Rate.vue?vue&type=script&lang=js&"
import style0 from "./Rate.vue?vue&type=style&index=0&id=4fd3e20b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fd3e20b",
  null
  
)

export default component.exports